/**
 * 语言切换公共组件
 */
// eslint-disable-next-line no-use-before-define
import React from 'react';
import { message, Select } from 'antd';
import { connect } from 'react-redux';
import { LANG_SWITCH, ACTION } from 'src/store/common/language';
import * as api from 'src/api';
import useFetchState from 'src/utils/useFetchState';
import { showLoading, hideLoading } from 'src/components/common/loding';
import { LangMessage } from 'src/store/common/language';
const { Option } = Select;

type Props = {
    dispatch: React.Dispatch<ACTION>;
    locale: string;
    className: string;
    Mes: LangMessage;
    bordered?: boolean;
    changeLang?: (val: string) => void;
}

export const LANG_OPT = [
    {
        label: 'English',
        value: 'en',
    },
    {
        label: 'España',
        value: 'es',
    },
];

const Lang: React.FC<Props> = (props) => {
    const { locale, dispatch, Mes, bordered = false, changeLang } = props;

    const [ lang, setLang ] = useFetchState(localStorage.getItem('language') || 'Languages');

    const handleChange = async (res: string) => {
        showLoading();
        try {
            setLang(res);
            const data = await api.lang.getLangResource(res);

            dispatch({
                type: LANG_SWITCH,
                value: {
                    locale: res,
                    message: data,
                },
            });
            localStorage.setItem('language', res);
        } catch (error) {
            console.error(error);
            message.error(typeof error === 'string' ? error : Mes['messageAlarmRequestfailrequestfail']);
        }
        hideLoading();
        if (changeLang && typeof changeLang === 'function') {
            await changeLang(res);
        }
    };

    return (
        <Select
            placeholder='Languages'
            defaultValue={locale || lang}
            bordered={bordered}
            onChange={handleChange}
        >
            <Option value='en_US'>English</Option>
            <Option value='es_ES'>Español</Option>
            {/* <Option value='zh_CN'>简体中文</Option>
            <Option value='fr_FR'>En français</Option> */}
        </Select>
    );
};

export default connect((state: any) => ({
    locale: state.langSwitch.locale,
    Mes: state.langSwitch.message,
}))(Lang);
